import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoMultiSelectMixin from './KendoMultiSelectMixin'

export default {
    name: 'kendo-multiselect',
    mixins: [ KendoMultiSelectMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        return h('input', [
            this.$slots['kendo-datasource']
        ])
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoMultiSelect/index.js